import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=29831da0&scoped=true&"
import script from "./FooterComp.vue?vue&type=script&lang=js&"
export * from "./FooterComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=29831da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29831da0",
  null
  
)

export default component.exports